var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.status.code === 'true')?_c('i',{staticClass:"fas fa-check success",attrs:{"aria-hidden":"true"}}):(_vm.status.code === 'false')?_c('i',{staticClass:"fas fa-times tertiary-color",attrs:{"aria-hidden":"true"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }